export const version = "bignumber/5.6.2";
//# sourceMappingURL=_version.js.map